export enum PusherEventsEnum {
  REQUEST_COMPLETE = 'request-completed',
  REQUEST_ACCEPTED = 'request-accepted',
  REQUEST_CANCEL = 'request-canceled',

  REQUEST_RECEIVED = 'request-received',
  AVAILABLE_REQUESTS = 'available-requests',
  REQUEST_REMOVED = 'request-removed',
  REQUEST_REROLLED = 'request-rerolled',
  REQUEST_UPDATE = 'request-update',
  REQUEST_LOST = 'request-lost',
  CANCELED_COURTESY = 'canceled_courtesy',
  REQUEST_TIPS = 'request-tips',
  APPLICATION_UPDATE = 'application-update',
  MATCHMAKING_UPDATE = 'matchmaking-update',
  PRODUCT_STREAMERS = 'product-streamers',
  STREAMERS_REFRESH = 'streamers-refresh',

  TEAMMATE_INVITE_TIMEOUT = 'teammate-invite-timeout',
  TEAMMATE_UPDATE = 'teammate-update',
  TEAMMATE_LOCK_IN = 'teammate-lock-in',
  INVITE_UPDATE = 'invite-update',
}
